import { Map } from 'immutable';
import { orderListActions } from '../orders-lists';
import { createOrder } from './order';

export function ordersReducer(state = new Map(), {payload, type}) {
  switch (type) {
    case orderListActions.FETCH_ORDERS_SUCCESS:
      return state.withMutations( orders => {
        payload.data.forEach( orderData => {
          if (!orders.has(orderData.id)) {
            orders.set(orderData.id, createOrder(orderData));
          }
        });
      });
    default:
      return state;
  }
}
